














import { Component } from 'vue-property-decorator';
import Create from '@/layouts/Create';

import CreateBlock from '@/views/CRUD/Create.vue';
import TitleReturn from '@/components/TitleReturn.vue';
import FormView from './_form.vue';

import PartnersModule from '@/store/partners';
import PartnerEntityModule from '@/store/partners/entity';
import ResponseHandlerModule from '@/store/modules/responseHandler';

@Component({
    components: {
        CreateBlock,
        TitleReturn,
        FormView,
    },
})
export default class PartnersAddPage extends Create {
    fieldErrors: Record<string, string> = {};
    
    returnBefore() {
        this.$router.push({ name: 'partners' });
    }

    init() {
        this.title = PartnersModule.pageSettings.titleAdd;
    }

    async create(data: any) {
        this.fieldErrors = {};
        try {
            await PartnerEntityModule.createNew(data);

            ResponseHandlerModule.showNotify({ message: 'Партнерское предложение создано', type: 'ok' });

            this.$router.push({ name: 'partners' });
        } catch (response) {
            const error = response.response.data;

            // unknown fields error
            if (error.message) {
                ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });
                return;
            }

            this.fieldErrors = error.errors.fields || {};
        }
    }

    async mounted() {
        await this.init();
    }
}
